module.exports = "https://static.wmbcdn.com/uniweb/images/10f2e8554131840cd207e56e2c530676.svg";